import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" · ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const formatPrice = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);

export const CATEGORY_LABELS = {
  talleres_presenciales: "Talleres Presenciales",
  talleres_online: "Talleres Online",
  cursos: "Cursos",
  terapia_individual: "Terapia Individual",
  terapia_pareja_familiar: "Terapia de Pareja y Familiar",
  orientacion_psicologica: "Orientación Psicológica",
  tutorias: "Tutorías",
};

export default API;
